/* eslint-disable */
// @ts-nocheck
/**
 * Injects the Pendo script.
 *
 * Copied from the Pendo Docs: https://support.pendo.io/hc/en-us/articles/360032201071-Client-side-data-installation
 * @param apiKey
 */
export function injectPendoScript(apiKey: string) {
    (function (p, e, n, d, o) {
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = [];
        v = ["initialize", "identify", "updateOptions", "pageLoad"];
        for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
                o[m] =
                    o[m] ||
                    function () {
                        o._q[m === v[0] ? "unshift" : "push"](
                            [m].concat([].slice.call(arguments, 0))
                        );
                    };
            })(v[w]);
        y = e.createElement(n);
        y.async = !0;
        y.src =
            "https://content.tracking.impero.com/agent/static/" +
            apiKey +
            "/pendo.js";
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
}
